var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLevelIcon3 = function SvgLevelIcon3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 7,
    x: 2,
    y: 13.5,
    fill: "#424242",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 12,
    x: 10,
    y: 8.5,
    fill: "#424242",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 17,
    x: 18,
    y: 3.5,
    fill: "#424242",
    rx: 1
  })));
};
export { SvgLevelIcon3 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHg9IjIiIHk9IjEzLjUiIHdpZHRoPSI1IiBoZWlnaHQ9IjciIHJ4PSIxIiBmaWxsPSIjNDI0MjQyIi8+CiAgICA8cmVjdCB4PSIxMCIgeT0iOC41IiB3aWR0aD0iNSIgaGVpZ2h0PSIxMiIgcng9IjEiIGZpbGw9IiM0MjQyNDIiLz4KICAgIDxyZWN0IHg9IjE4IiB5PSIzLjUiIHdpZHRoPSI1IiBoZWlnaHQ9IjE3IiByeD0iMSIgZmlsbD0iIzQyNDI0MiIvPgo8L3N2Zz4K";